import { v4 } from "uuid";

export class RunningJob {
	key:string = v4();
	Name:string ="";
	DossierID:number = 0;
	UserID:number = 0;

	public constructor(data?:any){
		if(!data) return;
		this.Name = data.Name;
		this.DossierID = data.DossierID;
		this.UserID = data.UserID;
	}

	public isSameJob(j:RunningJob):boolean {
		if (this.DossierID != j.DossierID) return false;
		if (this.UserID != j.UserID) return false;
		if (this.Name != j.Name) return false;
		return true;
	}
}